import React from 'react';
import '../styles/Spinner.css';

const Spinner = ({ size = 'medium', message = 'Loading...' }) => {
  return (
    <div className="spinner-container">
      <div className={`spinner spinner-${size}`}></div>
      <p className="spinner-message">{message}</p>
    </div>
  );
};

export default Spinner;